"use client";

// import { useDisplayStore } from "@/entities";

import { OrganizationGridSkeleton } from "./organization-grid-skeleton";
import { OrganizationListSkeleton } from "./organization-list-skeleton";

export function OrganizationDisplaySkeleton() {
  // const { displayMode } = useDisplayStore();
  const displayMode = "grid" as "grid" | "list"; // Mock value

  const renderDisplay = () => {
    switch (displayMode) {
      case "grid":
        return <OrganizationGridSkeleton />;
      case "list":
        return <OrganizationListSkeleton />;
      default:
        return <OrganizationGridSkeleton />;
    }
  };

  return (
    <div className="flex-1 overflow-hidden">
      {/* Отображение скелетона */}
      {renderDisplay()}
    </div>
  );
}
